import { Injectable } from "@angular/core";
import { BfxBaseBlotter } from "app/bfx-base-blotter/bfx-base-blotter";
import { BfxBlotterAction, TradeDealPromiseService, TradeDeal } from "shared/cubiq-services";
import { BfxRBACService } from "../../bfx-common/services/bfx-rbac.service";
import { BfxUserProfileService } from "../../bfx-common/services/bfx-user-profile.service";

import { LoggerService } from "@bfx/logger";
import {
  BfxBlotterTradeContextMenuItem,
  BfxTradeContextMenuService,
} from "./bfx-trade-contextmenu.service";
import { BfxTradeActionsService } from "./bfx-trade-actions.service";

const logger = LoggerService.for(__dirname);

@Injectable()
export class BfxTradeDetailsContextMenuService extends BfxTradeContextMenuService {
  /**********************************************************************/
  /* CONSTRUCTOR */

  constructor(
    protected tradeDealService: TradeDealPromiseService,
    protected rbacService: BfxRBACService,
    protected userProfileService: BfxUserProfileService,
    protected tradeActionService: BfxTradeActionsService,
  ) {
    super(tradeDealService, rbacService, userProfileService);
  }

  /**
   * @override
   */
  protected initMenuItems(): void {
    this.menuItems = [];

    this.actionSubject.subscribe((event) => this.tradeActionService.handleActionEvent(event));

    if (this.permissions.canViewTradeDetails) {
      this.menuItems.push(
        new BfxBlotterTradeContextMenuItem(
          BfxBlotterAction.ACTION_TRADE_VIEW_TRADE_DETAILS,
          "View Trade Details",
        ),
      );
    }

    this.menuItems.push(new BfxBlotterTradeContextMenuItem(BfxBlotterAction.SEPARATOR));
    if (this.permissions.canExportTrade) {
      this.menuItems.push(
        new BfxBlotterTradeContextMenuItem(BfxBlotterAction.ACTION_TRADE_EXPORT, "Export to CSV"),
      );
    }
  }

  /**
   * @override
   */
  public buildMenu(
    blotter: BfxBaseBlotter,
    pageX: number,
    pageY: number,
    selectedIds: Array<string>,
    selectedItems?: Array<TradeDeal> | null,
  ): void {
    this.selectedTradeDeals = selectedItems;
    let enabledItems: Array<BfxBlotterAction> = this.getEnabledActions(selectedItems, selectedIds);
    let actionDecorators: any = this.getActionDecorators(selectedItems);

    if ((blotter as any)?.checkEnabledContextItems != null) {
      (blotter as any).checkEnabledContextItems(enabledItems, selectedItems);
    }

    this.showMenuAt(blotter, pageX, pageY, enabledItems, actionDecorators);
  }
}
